<template>
  <div class="apps">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="true" @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>
    <div v-if="section != null && sections.includes(section)">
    <!-- Visualizer Section-->
      <div v-if="section == 'visualizer' && sections.includes('visualizer')" class="p-1" style="margin-top: 92px;">
        <Visualizer :key="compkeys.visualizer"></Visualizer>
      </div>
      <!-- Devices Section-->
      <div v-if="section == 'devices' && sections.includes('devices')" class="p-1" style="margin-top: 92px;">
        <Devices :key="compkeys.devices"></Devices>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderBar3 from '@/components/HeaderBar3.vue'
import Visualizer from '@/components/apps-components/autobackups/Visualizer.vue'
import Devices from '@/components/apps-components/autobackups/Devices.vue'

import axios from "axios";

export default {
  name: 'AutoBackups',
  components: {
    HeaderBar3,
    Visualizer,
    Devices
  },
  data(){
    return {
      site: null,
      service_mode: null, // PV | PB
      stage: null,        // D  | P
      customer: null,     // Solve
      loading: false,
      // View
      view: 'autobackups',
      hbref: 'hb_autobackups',
      section: null,
      preferred: 'visualizer',
      sections: [],
      apps: {},

      // Keys
      compkeys: {
        visualizer: 0,
        devices: 0
      },
      appdata: {section: null, sections: [], verification: true}
    }
  },
  methods:{
    solve(){
      this.loading = true
      const params = {view: this.view}
      const dest = this.site + '/suite/main/dnsuite'
      axios
          .get(dest, {params})
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps     = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
    },
    setSection_out(entry){
      this.section = entry
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.solve()
  }
}
</script>

